import { render, staticRenderFns } from "./ChangeOwnership.vue?vue&type=template&id=9b611b26"
import script from "./ChangeOwnership.vue?vue&type=script&lang=js"
export * from "./ChangeOwnership.vue?vue&type=script&lang=js"
import style0 from "./ChangeOwnership.vue?vue&type=style&index=0&id=9b611b26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports